import { render } from "./PhoneCalls.vue?vue&type=template&id=e444d966&scoped=true"
import script from "./PhoneCalls.vue?vue&type=script&lang=js"
export * from "./PhoneCalls.vue?vue&type=script&lang=js"

import "./PhoneCalls.vue?vue&type=style&index=0&id=e444d966&scoped=true&lang=scss"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e444d966"]])

export default __exports__